import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import { EntityBaseGqlService } from "../../api/EntityBaseGqlService.js";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { BackpackRequestBuilder } from "./requestBuilder.js";
class BackpackService extends EntityBaseGqlService {
  constructor(client, messageLocalizer) {
    super(client, new BackpackRequestBuilder(), messageLocalizer);
  }
  getErrorSeverity(_code) {
    return 0;
  }
  get(requestPayload) {
    return this.fetchData(requestPayload).pipe(
      map(({ responsePayload, ...response }) => {
        const resp = responsePayload?.getBackpackItems;
        return {
          ...response,
          requestPayload,
          responsePayload: resp?.items?.length ? {
            items: resp?.items,
            total: resp?.total_count
          } : { items: [], total: 0 }
        };
      })
    );
  }
}
export {
  BackpackService
};
//# sourceMappingURL=service.js.map
